
  import { defineComponent, onMounted, ref } from 'vue';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useRoute, useRouter } from 'vue-router';
  import { useAbility } from '@casl/vue';

  export default defineComponent({
    name: 'auctions-properties-overview',
    setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const route = useRoute();
      const router = useRouter();
      const { can } = useAbility();
      const property = ref<any | null>(null);

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      const formatCurrency = (amount) => {
        if (!amount) return 'N/A';
        return new Intl.NumberFormat('en-KW', {
          style: 'currency',
          currency: 'KWD',
        }).format(amount);
      };

      const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleString('en-KW');
      };

      onMounted(async () => {
        setCurrentPageBreadcrumbs(translate('propertyOverview'), [
          translate('auctions'),
          translate('properties'),
        ]);

        const { data } = await store.dispatch(
          Actions.GET_PROPERTY_DETAILS,
          route.params.id
        );
        property.value = data.data;
      });

      const goTo = (pageName) => {
        router.push({ name: pageName, params: { id: route.params.id } });
      };

      const goBack = () => {
        router.back();
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        property,
        translate,
        can,
        goBack,
        goTo,
        formatCurrency,
        formatDate,
      };
    },
  });
